import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { marketingPageFor, marketingUrl } from '@/lib/marketingSeo';

const STATIC_HEAD_TAGS = [
  'link[rel="canonical"]',
  'meta[name="description"]',
  'meta[property="og:title"]',
  'meta[property="og:description"]',
  'meta[property="og:url"]',
  'meta[name="twitter:title"]',
  'meta[name="twitter:description"]',
];

/**
 * Title, description and canonical for the marketing page being shown. The
 * server (api/tenant-page.ts) renders the same values into the HTML for
 * crawlers; this keeps them right after client-side navigation. The static
 * copies from index.html are removed once Helmet's take over, so the head never
 * carries two canonicals or descriptions.
 */
export function MarketingSeo() {
  const { pathname } = useLocation();
  const page = marketingPageFor(pathname);

  useEffect(() => {
    if (!page) return;
    document.querySelectorAll(STATIC_HEAD_TAGS.map((s) => `${s}:not([data-rh])`).join(',')).forEach((el) => el.remove());
  }, [page]);

  if (!page) return null;
  const url = marketingUrl(page.path);
  return (
    <Helmet>
      <title>{page.title}</title>
      <meta name="description" content={page.description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
    </Helmet>
  );
}
